<h1 mat-dialog-title>Master Password</h1>
<div mat-dialog-content>
  <p>
    Set your Master Password, your data can only be decrypted with this password
  </p>
  <mat-form-field appearance="fill">
    <mat-label>Master Password</mat-label>
    <input
      type="password"
      data-cy="master-password-input"
      matInput
      [(ngModel)]="mpwd"
    />
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Confirm Master Password</mat-label>
    <input
      type="password"
      data-cy="master-password-input-confirm"
      matInput
      [(ngModel)]="mpwdConfirm"
    />
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">No Thanks</button>
  <button
    mat-button
    [mat-dialog-close]="mpwd"
    [disabled]="!validate()"
    cdkFocusInitial
  >
    Ok
  </button>
</div>
